'use client';

import React from 'react';
import cn from 'classnames';
import styles from './FloatingCircles.module.scss';

export interface FloatingCirclesProps {
  /** Additional CSS class */
  className?: string;
  /** Whether animation is playing */
  playing?: boolean;
  /** Custom inline styles */
  style?: React.CSSProperties;
}

export const FloatingCircles: React.FC<FloatingCirclesProps> = ({
  className,
  playing = true,
  style,
}) => (
  <div
    className={cn(styles.floatingCircles, !playing && styles.paused, className)}
    style={style}
  >
    <div className={styles.core}>
      <div className={cn(styles.circle, styles.teal)} />
      <div className={cn(styles.circle, styles.lavender)} />
      <div className={cn(styles.circle, styles.gray)} />
    </div>
  </div>
);

export default FloatingCircles;
